'use strict';

var App = require('app');
var AppState = require('app_state');
var Consts = require('consts');
var AbstractFormView = require('components/common/views/abstract_form_view');
var Decorator = require('utils/decoration');
var Misc = require('utils/misc');
var i18n = require('utils/i18n');
var Notification = require('utils/notification');

var DialogView = AbstractFormView.extend({
    template: require('components/profile/templates/settings_dialog'),
    tagName: 'div',
    id: 'modal-body',

    controller: undefined,

    events: {
        'click button#js-success': 'validateForm',
    },

    initialize: function (options) {
        this.fieldType = options.parameter.el_id;
        this.controller = options.controller;

        AbstractFormView.prototype.initialize.apply(this, [{ inputFields: options.inputFields }]);
    },

    templateHelpers: function () {
        var fieldNameToPrefix = {
            username: i18n.TR('Benutzername ist '),
            email: i18n.TR('E-Mail ist'),
            language: i18n.TR('Sprache ist'),
            newPassword: i18n.TR('Passwort ist'),
            isExpert: i18n.TR('Darstellung ist'),
        };
        return $.extend(this.getOption('parameter'), { errorPrefix: fieldNameToPrefix[this.fieldType] });
    },

    validateForm: function (e) {
        e.preventDefault();
        var self = this;

        if (this.allFieldsValid()) {
            var form = Backbone.Syphon.serialize(this);
            self.options.parameter.content = form.username || form.email || form.language || '';
            Decorator.disableElement('.modal-dialog');
            this.controller.updateUserData({
                form: form,
                success: function () {
                    App.hideModal();
                    App.trigger('profile:show:settings');

                    switch (form.updateType) {
                        case 'TypeLanguageUpdate': {
                            var languageChanged = i18n.setLanguage(form.language);
                            $.when(languageChanged).done(function () {
                                App.navigate('profile/changed');
                                location.reload(true);
                            });
                            break;
                        }
                        case 'TypeEmailUpdate': {
                            Notification.show('info', i18n.TR('Info'), self.options.parameter.success_message, 5000);
                            break;
                        }
                        default: {
                            Notification.show('success', i18n.TR('Erfolg'), self.options.parameter.success_message);
                        }
                    }
                },
                error: function (error) {
                    self.errors = error;
                    self.formData = form;
                    App.refreshModal(self);
                },
            });
        }
    },
});

var MessageView = Marionette.ItemView.extend({
    template: require('components/profile/templates/messages'),

    ui: {
        save: '#js-save',
        infos: '.js-info-toggle',
    },
    events: {
        'click #js-save': 'save',
    },

    initialize: function () {
        this.config = AppState.user.getPreferences() || {
            messages: true,
            updates: true,
            frontend_version: 'classic',
        };
    },

    serializeData: function () {
        return {
            elements: [
                {
                    id: 'messages',
                    text: i18n.TR('Wartungsarbeiten'),
                    description: i18n.TR(
                        'Informiert über geplante Wartungsarbeiten und andere Einschränkungen im Funktionsumfang.'
                    ),
                    isEnabled: this.config.messages,
                },
                {
                    id: 'updates',
                    text: i18n.TR('Aktualisierungen'),
                    description: i18n.TR('Informiert über Updates und neue Funktionen.'),
                    isEnabled: this.config.updates,
                },
            ],
        };
    },

    save: function () {
        // get the state for each message
        var self = this;
        _.each(this.ui.infos, function (info) {
            var pref = $(info).attr('id').split('-')[2];
            self.config[pref] = $(info).context.checked;
        });

        // save the changes in the DB
        AppState.saveInfoConfig(this.config);
        App.hideModal();
    },
});

var FrontendVersionView = Marionette.ItemView.extend({
    template: require('components/profile/templates/frontend_version'),

    ui: {
        save: '#js-save',
    },
    events: {
        'click #js-save': 'save',
    },

    initialize: function () {
        this.config = AppState.user.getPreferences() || {
            messages: true,
            updates: true,
            frontend_version: 'classic',
        };
    },

    serializeData: function () {
        return {
            label: i18n.TR('Ansicht'),
            el_id: 'version',
            dropdownItems: [
                {
                    key: 'classic',
                    value: i18n.TR('Klassisch'),
                },
                {
                    key: 'latest',
                    value: i18n.TR('Neue Version'),
                },
            ],
            version: this.config.frontend_version,
        };
    },

    save: function () {
        App.hideModal();

        var selection = document.getElementById('version-input').value;
        if (this.config.frontend_version != selection) {
            this.config.frontend_version = selection;
            AppState.saveInfoConfig(this.config);
            App.trigger('profile:show:settings');
        }
    },
});

var ProfileView = Marionette.ItemView.extend({
    template: require('components/profile/templates/settings'),
    controller: undefined,

    events: {
        'click button': 'showDialog',
    },

    initialize: function (options) {
        this.controller = options.controller;
        this.deviceSummaryList = this.summarizeDeviceList(options.deviceSummary);

        if (options.isLangChange) {
            setTimeout(function () {
                App.navigate('profile/settings');
            }, 1);

            Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Die Aktualisierung der Sprache war erfolgreich.'));
        }
    },

    showDialog: function (e) {
        e.preventDefault();
        this.controller.showDialog(e);
    },

    serializeData: function () {
        var data = Marionette.LayoutView.prototype.serializeData.apply(this, arguments);

        var user = AppState.user.toJSON();
        var frontendVersion = (AppState.user.getPreferences() || {}).frontend_version || 'classic';

        user.lang = i18n.supportedLanguages[user.lang];
        data.devices = this.deviceSummaryList;

        data.setting = [
            { id: 'username', key: i18n.TR('Benutzername'), value: user.name },
            { id: 'email', key: i18n.TR('E-Mail'), value: user.email },
            {
                id: 'phone',
                key: i18n.TR('Handy'),
                value: user.phone || i18n.TR('Keine Handynummer gespeichert.'),
                hasPhoneNumber: user.phone,
            },
            { id: 'language', key: i18n.TR('Sprache'), value: user.lang },
            { id: 'password', key: i18n.TR('Passwort'), value: '*********', hasMFAenabled: user.mfa_active },
            {
                id: 'isExpert',
                key: i18n.TR('Darstellung'),
                value: user.is_expert ? i18n.TR('Expertenmodus') : i18n.TR('Standard'),
            },
            {
                id: 'version',
                key: i18n.TR('Ansicht'),
                value: frontendVersion == 'classic' ? i18n.TR('Klassisch') : i18n.TR('Neue Ansicht'),
            },
        ];

        return data;
    },

    // returns a color-suffix corresponding to the worst status of the given device list.
    getDeviceStatusColor: function (status) {
        switch (status) {
            case -1:
                return 'danger';
            case 0:
                return 'success';
            case -2:
            case -3:
                return 'primary';
            default:
                return 'warning';
        }
    },

    summarizeDeviceList: function (list) {
        var self = this;
        return _.sortBy(
            Misc.selectWhere(list, undefined, function (item) {
                var category = item.features.category;
                var catData = Consts.DeviceCategory[category] || {};
                var status = item.features.status;
                return {
                    category: category,
                    name: catData.name,
                    count: item.stats.id.count,
                    color: self.getDeviceStatusColor(status),
                    icon: catData.icon,
                };
            }),
            function (item) {
                return item.name + item.status;
            }
        );
    },
});

module.exports = {
    ProfileView: ProfileView,
    DialogView: DialogView,
    MessageView: MessageView,
    FrontendVersionView: FrontendVersionView,
};
